
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ChipButton from '@/ui-components/ChipButton.vue';

@Component({
	name: 'ToggleButton',
	components: { ChipButton },
})
export default class ToggleButton extends Vue {
	@Prop({ default: false }) active: boolean;
	@Prop({ default: false }) negative: boolean;
	@Prop({ default: false }) icon: boolean;
	@Prop({ default: false }) noBorders: boolean;
	@Prop({ default: false }) disabled: boolean;
}
